import React, { useState } from 'react';
import { useAuthHeader } from 'react-auth-kit';
import axios from 'axios';
import { Modal, Container, Row, Col, ButtonToolbar, Button, Form, FormCheck} from 'react-bootstrap';
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';

function DefaultModal(props) {
    const authHeader = useAuthHeader();

        const apiUrl = process.env.REACT_APP_URL;
        const [contacts, setContacts] = useState([{ name: '', phone_number: '', email: '' }]);

        const handleAddContacts = () => {
            setContacts([...contacts, {
                name: '',
                phone_number: '',
                email: ''
            }]);
          };

        const handleContactChange = (index, field, value) => {
            const newContacts = [...contacts];
            newContacts[index][field] = value;
            setContacts(newContacts);
        };
        const handleButtonClick = (event) => {
            // alert('Botón de Guardar presionado');
            event.preventDefault();
            const data = {
                'company_name': event.target.company_name.value,
                'legal_name': event.target.legal_name.value,
                'rfc': event.target.rfc.value,
                'days_to_pay': event.target.days_to_pay.value,
                'salesman_id': event.target.salesman_id.value,
                'regimen_fiscal': event.target.regimen_fiscal.value || null,
                'uso_cfdi': event.target.uso_cfdi.value || null,
                'codigo_postal': event.target.codigo_postal.value || null,
                'email': event.target.client_email.value || null,
                'contacts': contacts};
            axios({
                method:'POST',
                url:apiUrl+'/finance/client',
            headers: {
                Authorization: authHeader()
            },
                data: data
            }).then(response => {
                console.log(response);
                props.onHide();
            })
            .catch(error => {
                console.log(error);
                alert(error);
            });
        }
        return (
            <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter">
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Agregar Cliente
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container>
                        <Form onSubmit={handleButtonClick}>
                            <Row className="mb-3">
                                <h4>Datos del cliente</h4>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="company_name">
                                    <Form.Label>Nombre de la Empresa</Form.Label>
                                    <Form.Control placeholder="Kinexion" />
                                </Form.Group>
                                <Form.Group as={Col} controlId="legal_name">
                                    <Form.Label>Razón Social</Form.Label>
                                    <Form.Control placeholder="NEXATEC" />
                                </Form.Group>
                                <Form.Group as={Col} controlId="rfc">
                                    <Form.Label>RFC</Form.Label>
                                    <Form.Control placeholder="RFC123456" />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="salesman_id">
                                    <Form.Label>Vendedor</Form.Label>
                                    <Form.Select defaultValue="Choose...">
                                        <option value='0'></option>
                                        <option value='3'>Cristopher</option>
                                        <option value='4'>Xavier</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="days_to_pay">
                                    <Form.Label>Días de crédito</Form.Label>
                                    <Form.Control
                                            type="number"
                                            min="5"
                                            max="90"
                                            step="5"
                                            defaultValue="5"
                                            />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <h6>SAT / Carta Porte</h6>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} controlId="regimen_fiscal">
                                    <Form.Label>Régimen Fiscal</Form.Label>
                                    <Form.Select defaultValue="">
                                        <option value="">Seleccionar...</option>
                                        <option value="601">601 - General de Ley PM</option>
                                        <option value="603">603 - PM Fines no Lucrativos</option>
                                        <option value="605">605 - Sueldos y Salarios</option>
                                        <option value="606">606 - Arrendamiento</option>
                                        <option value="608">608 - Demás ingresos</option>
                                        <option value="610">610 - Residentes en el Extranjero</option>
                                        <option value="612">612 - PF Act. Empresariales</option>
                                        <option value="620">620 - Soc. Cooperativas</option>
                                        <option value="621">621 - Incorporación Fiscal</option>
                                        <option value="622">622 - Act. Agrícolas/Ganaderas</option>
                                        <option value="623">623 - Grupos de Sociedades</option>
                                        <option value="624">624 - Coordinados</option>
                                        <option value="625">625 - Plataformas Tecnológicas</option>
                                        <option value="626">626 - RESICO</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="uso_cfdi">
                                    <Form.Label>Uso CFDI</Form.Label>
                                    <Form.Select defaultValue="">
                                        <option value="">Seleccionar...</option>
                                        <option value="G01">G01 - Adquisición de mercancías</option>
                                        <option value="G02">G02 - Devoluciones/descuentos</option>
                                        <option value="G03">G03 - Gastos en general</option>
                                        <option value="I01">I01 - Construcciones</option>
                                        <option value="I02">I02 - Mobiliario y equipo</option>
                                        <option value="I03">I03 - Equipo de transporte</option>
                                        <option value="I04">I04 - Equipo de cómputo</option>
                                        <option value="I08">I08 - Otra maquinaria</option>
                                        <option value="P01">P01 - Por definir</option>
                                        <option value="S01">S01 - Sin efectos fiscales</option>
                                        <option value="CP01">CP01 - Pagos</option>
                                    </Form.Select>
                                </Form.Group>
                                <Form.Group as={Col} controlId="codigo_postal">
                                    <Form.Label>Código Postal</Form.Label>
                                    <Form.Control placeholder="44100" />
                                </Form.Group>
                                <Form.Group as={Col} controlId="client_email">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control type="email" placeholder="cliente@empresa.com" />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col}>
                                <h4>Contactos</h4>
                                </Form.Group>
                            </Row>
                            {contacts.map((row, index) => (
                                <div key={index}>
                                    <Row className="mb-3">
                                    <Form.Group as={Col} controlId={`name_${index}`}>
                                        <Form.Label>Contacto</Form.Label>
                                        <Form.Control
                                        placeholder="Juan"
                                        value={row.name}
                                        onChange={(e) => handleContactChange(index, 'name', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`phone_number_${index}`}>
                                        <Form.Label>Teléfono</Form.Label>
                                        <Form.Control
                                        placeholder="123-456-7890"
                                        value={row.phone_number}
                                        onChange={(e) => handleContactChange(index, 'phone_number', e.target.value)}
                                        />
                                    </Form.Group>
                                    <Form.Group as={Col} controlId={`email_${index}`}>
                                        <Form.Label>Email</Form.Label>
                                        <Form.Control
                                        placeholder="example@gmail.com"
                                        value={row.email}
                                        onChange={(e) => handleContactChange(index, 'email', e.target.value)}
                                        />
                                    </Form.Group>
                                    </Row>
                                </div>
                            ))}
                            <div className="mb-3" style={{textAlign:"end"}}>
                                <Button onClick={handleAddContacts}>+</Button>
                            </div>
                            <Button type="submit" value="Submit">Guardar</Button>
                        </Form>
                    </Container>
                </Modal.Body>
            </Modal>
        );
}

class ModalWithGrid extends React.Component {
    constructor(...args) {
        super(...args);
        this.state = { modalShow: false };
    }

    render() {
        let add_new_trip = () => {this.props.setData(); this.setState({ modalShow: false });}
        return (
            <ButtonToolbar>
                <Button
                    variant="primary"
                    onClick={() => this.setState({ modalShow: true })}
                >
                    Agregar Cliente
                </Button>
                <DefaultModal show={this.state.modalShow} onHide={add_new_trip} />
            </ButtonToolbar>
        );
    }
}

export default ModalWithGrid;
